export function getWeekByDate(
  { locale, date }: { locale: Intl.LocalesArgument; date: Date } = {
    locale: 'en',
    date: new Date(),
  },
) {
  const copyDate = new Date(date)
  const numberDayOfWeek = copyDate.getDay() - 1 // Sunday is 0, subtract 1 to get Monday as 0

  const firstDayOfWeek = new Date(
    copyDate.setDate(copyDate.getDate() - numberDayOfWeek),
  )

  const weekDays = [...Array(7)].map((_, i) => {
    const weekDayDate = new Date(firstDayOfWeek)
    weekDayDate.setDate(firstDayOfWeek.getDate() + i)

    const weekday = weekDayDate.toLocaleDateString(locale, {
      weekday: 'short',
    })

    const day = weekDayDate.toLocaleDateString(locale, {
      day: 'numeric',
    })

    const month = weekDayDate.toLocaleDateString(locale, {
      month: 'numeric',
    })

    const year = weekDayDate.toLocaleDateString(locale, {
      year: 'numeric',
    })

    return {
      weekday,
      day,
      month,
      year,
    }
  })

  return weekDays
}
